// Enter all your detials in this file
// Logo images
// Profile Image
import profile from "./assets/os.png";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import tailwind from './assets/techstack/tailwind.png';
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
// Porject Images
import Mogo from "./assets/projects/mogo.png";
import restaurant from "./assets/projects/restraunt.PNG";
import card_game from "./assets/projects/card-game.PNG";
import weather_app from "./assets/projects/weather app.png";
import todo from "./assets/projects/to-do-list.png";
import angular_cart from "./assets/projects/angualr cart.webp";
import ecommerce from "./assets/projects/ecommerce.png";
import netflix from "./assets/projects/netflix.jpg";
import medica from "./assets/projects/Medica.webp";
import twitter from "./assets/projects/twitter.png";
import rock from "./assets/projects/rock.jpg";
import millionair from "./assets/projects/millionair.jpg";
import wordpress from "./assets/techstack/wordpress.png"
import jquery from "./assets/techstack/jquery.png"
import typeScript from "./assets/techstack/typescript.png"
import vscode from "./assets/techstack/vscode.png"
import woocommerce from "./assets/projects/ecommerce.png"
import agency from "./assets/projects/agency.PNG"
// Logos


// Enter your Personal Details here
export const personalDetails = {
	name: 'Osama Saad',
	tagline: 'I build things for web',
	img: profile,
	about: `My name is Osama Saad I'm a Front End Developer based in Egypt ☀️. I describe myself as a passionate developer who loves coding, open source, and the web platform 💜.

Aside from my job, I like to create and contribute to open source projects. That helps me to learn a ton of new stuff, grow as a developer and support other open source projects  `,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
	linkdein: 'https://www.linkedin.com/in/osama-saad-iti/',
	github: 'https://github.com/osama7007',
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Frontend Web Developer Trainee",
    Company: `ITI`,
    Location: "Alexandria",
    Type: "Full Time",
    Duration: "Aug 2022 - Nov 2022",
  },
];

// Enter your Education Details here
export const eduDetails = [
	{
		Position: 'Computer Enginner',
		Company: 'MET',
		Location: 'Mansourah , Egypt',
		Type: 'Full Time',
		Duration: 'Sep 2013 - May 2018',
	},
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  bootstrap: bootstrap,
  wordpress: wordpress,
  git: git,
  github: github,
  vscode: vscode,
  tailwind : tailwind ,
  jquery : jquery , 
  typeScript: typeScript

};

// Enter your Project Details here
export const projectDetails = [
	{
		title: 'Medica',
		image: medica,
		description: `Medica is full booking wxamination website as weel as social meida features`,
		techstack: 'ReactJS , redux-toolKit , asyncThunk ,routing 6.4 , Antd , Framer motion , Lottie files , Swiper , Toastify , Bootstrab , React Bootstrab , react icons ',
		live_demo : "https://medicaa.netlify.app/",
		githubLink: 'https://github.com/osama7007/Medica',
	},
	{
		title: 'Netflex Clone With react',
		image: netflix,
		description: `Netflix clone with react  , css , no any styling frameworks`,
		techstack: 'HTML/SCSS,JavaScript , React',
		live_demo : "https://netflixos.netlify.app/",
		githubLink: 'https://github.com/osama7007/Netflix-clone',
	},
	{
		title: "Digital Agency",
		image: agency ,
		description: `Wordpress digital afency 7 pages with modern style`,
		techstack: 'Wordpress , elementor',
		live_demo : "https://dev-wordpress-wallet.pantheonsite.io/",
	},
	{
		title: 'Woocommerce',
		image:woocommerce,
		description: `woo commerce using wordpress and blocksy theme biulder providing all purchasing process`,
		techstack: 'Wordpress , Blocksy , woocommerce',
		live_demo : "https://dev-ecommerce-o.pantheonsite.io/login/?redirect_to=https%3A%2F%2Fdev-ecommerce-o.pantheonsite.io%2F",
	},
	{
		title: 'Twitter Clone',
		image: twitter,
		description: `Netflix clone with react , Tailwind`,
		techstack: 'HTML/SCSS,JavaScript , React',
		live_demo : "https://twitter-tailwind-clone.netlify.app/",
		githubLink: 'https://github.com/osama7007/Netflix-clone',
	},
	{
		title: 'Responsive Mogo webpage clone',
		image: Mogo,
		description: `Responsive webpage design using HTML ,CSS , Bootstrab, media-query and JavaScript`,
		techstack: 'HTML/SCSS/Bootstrap, JavaScript',
		live_demo : "https://magical-raindrop-2457b2.netlify.app/",
		githubLink: 'https://github.com/osama7007/Mogo-clone',
	},
	{
		title: 'Memory card game',
		image: card_game,
		description: `Memory card game using JavaScript , let's have some fun ☺`,
		techstack: 'HTML/CSS, JavaScript',
		live_demo : "https://os-memory-card-game.netlify.app/",
		githubLink: 'https://github.com/osama7007/memory-card-game',
	},
	{
		title: 'Millionair Quiz App',
		image: millionair,
		description: `Millionair Quiz App Game`,
		techstack: 'HTML/CSS, JavaScript , ReactJS',
		githubLink: 'https://github.com/osama7007/millionair-Quiz-App',
	},
	{
		title: 'Rock , Papper , Scissor',
		image: rock,
		description: `Rock , Papper , Scissor game`,
		techstack: 'HTML/CSS/media-query, JavaScript',
		live_demo : "https://rock-papper-cissor.netlify.app/",
		githubLink: 'https://github.com/osama7007/rock-paper-scissor',
	},
	{
		title: 'Todo List',
		image: todo,
		description: `To do App using react typescript`,
		techstack: 'HTML/CSS/media-query, JavaScript',
		live_demo : "https://react-todo-typescript-os.netlify.app/",
		githubLink: 'https://github.com/osama7007/React-TypeScript-Todo-',
	},
	{
		title: 'Responsive Restaurant webpage clone',
		image: restaurant,
		description: `Responsive webpage design using HTML ,CSS , media-query`,
		techstack: 'HTML/CSS/media-query, JavaScript',
		githubLink: 'https://github.com/osama7007/Restaurant-webpage.git',
	},
	{
		title: 'Weather app using React',
		image: weather_app,
		description: `weather app using React and wether open api `,
		techstack: 'HTML/CSS, JavaScript',
		githubLink: 'https://github.com',
	},
	{
		title: 'Ecommerce using React',
		image: ecommerce,
		description: `Ecommerce website `,
		techstack: 'ReactJS , redux-toolKit , asyncThunk ,routing 6.4 , Antd , Framer motion , Lottie files , Swiper , Toastify , Bootstrab , React Bootstrab , react icons ',
		githubLink: 'https://github.com/osama7007/react-ecommerce-app-',
	},
	{
		title: 'Shopping cart using Angular',
		image: angular_cart,
		description: `Shopping cart using Angular and reactive form, provide guard routes and more functionalities`,
		techstack: 'HTML/CSS, JavaScript',
		githubLink: 'https://github.com',
	},
];

// Enter your Contact Details here
export const contactDetails = {
  email: "osamasaadelsaeed@gmail.com",
  phone: "+201101525819",
};
